export class Config {
  static ApiUrl: string = process.env.VUE_APP_API_URL;

  static GoogleMapApiKey: string = process.env.VUE_APP_GOOGLE_MAP_API_KEY;

  static MerchantsPageLimit: number = parseInt(process.env.VUE_APP_MERCHANTS_PAGE_LIMIT, 10) || 20;

  static FirebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
  }

  static SquareConfig = {
    squareApplicationId: process.env.VUE_APP_SQUARE_APPLICATION_ID,
  }
}
